import swal from 'sweetalert2'
const colorButton = {
  red:"#ff3d00",
  blue:"#00E5FF",
  green:"#00E676",
  yellow:"#ffd400"
}
const iconButton = {
  question:"question",
  warning:"warning",
}
export const QuestionCallback = (text,color, callback,icon = "question") => {
  
  swal({
    title: 'ยืนยัน',
    text: text,
    type: iconButton[icon],
    focusConfirm:false,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    showCancelButton: true,
    confirmButtonColor:colorButton[color]
  }).then(result => {
    if (result.value) {
      if (callback) {
        callback()
      }
    }
  })
}
export const Question2Choice = (question_text, confirmButtonText,cancelButtonText, callback,callbackCancel) => {
  var datas = {
    type: "question",
    title: "Please Choice",
    text: question_text,
    focusConfirm: false,
    confirmButtonText: confirmButtonText,
    confirmButtonColor: "#8bc34a",
    showCancelButton: true,
    cancelButtonColor: "#666666",
    cancelButtonText: cancelButtonText,
    allowOutsideClick: false
  }
  swal(datas).then(result => { 
    if (result.value) {
      if (callback) {
        callback()
      } 
    }
    if(result.dismiss == "cancel"){
      if (callbackCancel) {
        callbackCancel()
      } 
    } 
  })
}